"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@mui/material/styles");

var _AppBar = _interopRequireDefault(require("@mui/material/AppBar"));

var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));

var _Menu = _interopRequireDefault(require("@mui/material/Menu"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Language = _interopRequireDefault(require("@mui/icons-material/Language"));

var _Cached = _interopRequireDefault(require("@mui/icons-material/Cached"));

var _BookmarkAdd = _interopRequireDefault(require("@mui/icons-material/BookmarkAdd"));

var _BookmarkRemove = _interopRequireDefault(require("@mui/icons-material/BookmarkRemove"));

var _Bookmarks = _interopRequireDefault(require("@mui/icons-material/Bookmarks"));

var _Switch = _interopRequireDefault(require("@mui/material/Switch"));

var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));

var _Check = _interopRequireDefault(require("@mui/icons-material/Check"));

var _reactI18next = require("react-i18next");

var Header = function Header(_ref) {
  var title = _ref.title,
      market = _ref.market,
      variety = _ref.variety,
      languages = _ref.languages,
      bookmarks = _ref.bookmarks,
      onBookmarkEdit = _ref.onBookmarkEdit,
      onBookmarkClick = _ref.onBookmarkClick,
      onThemeToggle = _ref.onThemeToggle;
  var theme = (0, _styles.useTheme)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      bmAnchor = _useState2[0],
      setBmAnchor = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      langAnchor = _useState4[0],
      setLangAnchor = _useState4[1];

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var isBookmarked = bookmarks.find(function (bm) {
    return bm.market === market && bm.variety === variety;
  });

  var changeLanguage = function changeLanguage(l) {
    i18n.changeLanguage(l);
    setLangAnchor(null);
  };

  return /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "fixed",
    sx: {
      backgroundColor: theme.palette.primary.dark,
      top: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    sx: {
      justifyContent: "space-between",
      pl: '8px !important',
      pr: '0 !important'
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, title), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    sx: {
      ml: 'auto'
    },
    size: "large",
    "aria-label": isBookmarked ? t('remove from bookmark') : t('add to bookmark'),
    "aria-haspopup": "false",
    onClick: onBookmarkEdit,
    color: "inherit"
  }, isBookmarked ? /*#__PURE__*/_react.default.createElement(_BookmarkRemove.default, null) : /*#__PURE__*/_react.default.createElement(_BookmarkAdd.default, null)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    size: "large",
    "aria-label": t("browse bookmarks"),
    "aria-controls": "bookmark-menu",
    "aria-haspopup": "true",
    onClick: function onClick(event) {
      return bookmarks.length > 0 ? setBmAnchor(event.currentTarget) : null;
    },
    color: "inherit"
  }, /*#__PURE__*/_react.default.createElement(_Bookmarks.default, null)), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    id: "bookmarks-menu",
    anchorEl: bmAnchor,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: Boolean(bmAnchor),
    onClose: function onClose() {
      return setBmAnchor(null);
    }
  }, bookmarks.map(function (bm) {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: bm.market,
      onClick: function onClick() {
        onBookmarkClick(bm);
        setBmAnchor(null);
      }
    }, isBookmarked && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_Check.default, null)), t(bm.market), " , ", t(bm.variety));
  })), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    size: "large",
    "aria-label": t("change language"),
    "aria-controls": "language-menu",
    "aria-haspopup": "true",
    onClick: function onClick(event) {
      return setLangAnchor(event.currentTarget);
    },
    color: "inherit"
  }, /*#__PURE__*/_react.default.createElement(_Language.default, null)), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    id: "language-menu",
    anchorEl: langAnchor,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: Boolean(langAnchor),
    onClose: function onClose() {
      return setLangAnchor(null);
    }
  }, languages.map(function (lang) {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: lang.isoCode,
      onClick: function onClick() {
        return changeLanguage(lang.isoCode);
      }
    }, lang.isoCode === i18n.language && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_Check.default, null)), lang.name);
  })), /*#__PURE__*/_react.default.createElement(_Switch.default, {
    inputProps: {
      'aria-label': t('toggle theme')
    },
    checked: theme.name === 'dark',
    onChange: onThemeToggle
  })));
};

exports.Header = Header;